import { Controller } from 'stimulus'

export class NavController extends Controller {
  static targets = [
    'navToggle',
    'navContent',
    'collapseToggle',
    'collapseContent',
    'collapseContainer',
  ]

  // ref definition
  navToggleTarget: HTMLButtonElement
  navContentTarget: HTMLUListElement
  collapseToggleTarget: HTMLButtonElement
  collapseContentTarget: HTMLUListElement
  collapseContainerTarget: HTMLUListElement

  private _subscriptions: VoidFunction[] = []

  set isCollapsed(isCollapsed: boolean) {
    this._isCollapsed = isCollapsed

    this.collapseToggleTarget.setAttribute(
      'aria-expanded',
      String(!isCollapsed)
    )
    this.collapseContentTarget.setAttribute('aria-hidden', String(isCollapsed))
  }

  get isCollapsed() {
    return this._isCollapsed
  }

  private _isCollapsed = true

  set isOpened(isOpened: boolean) {
    this._isOpened = isOpened

    this.navToggleTarget.setAttribute('aria-expanded', String(isOpened))
    this.navContentTarget.setAttribute('aria-hidden', String(!isOpened))
  }

  get isOpened() {
    return this._isOpened
  }

  private _isOpened = true

  connect() {
    const mql = window.matchMedia('(max-width: 899px)')
    const onScreenChanged = this._onScreenChanged.bind(this)

    mql.addListener(onScreenChanged)

    this._subscriptions.push(() => mql.removeListener(onScreenChanged))

    // init
    onScreenChanged(mql)
  }

  disconnect() {
    this._subscriptions.forEach((unsubscribe) => unsubscribe())
  }

  toggle() {
    this.isOpened = !this.isOpened
  }

  show() {
    if (window.matchMedia('(max-width: 899px)').matches) {
      return
    }

    this.isCollapsed = false
  }

  hide() {
    if (window.matchMedia('(max-width: 899px)').matches) {
      return
    }

    this.isCollapsed = true
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed

    if (!this.isCollapsed) {
      this.collapseContentTarget.focus()
    }
  }

  handleClickOutside(event: MouseEvent) {
    if (this.isCollapsed) {
      return
    }

    if (!this.collapseContainerTarget.contains(event.target as Element)) {
      this.isCollapsed = true
    }
  }

  private _onScreenChanged({ matches }: { matches: boolean }) {
    this.isOpened = !matches
    this.isCollapsed = true

    this.navToggleTarget.setAttribute('aria-hidden', String(this.isOpened))
  }
}
